import React from "react";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-inner">
      <div>
        <p className="footer-heading">Brian Hodgers for Florida House District 32</p>
        <p>Paid for by Brian Hodgers, Republican for State Representative.</p>
      </div>
      <div className="footer-links">
        <a href="mailto:brian@brianforflorida.com">brian@brianforflorida.com</a>
        <a href="tel:3212094645">(321) 209-4645</a>
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-and-conditions">Terms & Conditions</Link>
      </div>
    </div>
    <p className="footer-meta">&copy; {new Date().getFullYear()} Brian Hodgers for Florida House District 32</p>
  </footer>
);

export default Footer;
